<template>
  <a :href="href" @click.stop="clickBtn" :class="btnClass">
    {{btnLabel}}
  </a>
</template>

<script>
// 两个 large norm small
// 三个状态 active loading disabled
export default {
  props: {
    btnStatus: {
      type: String,
      default: 'active',
      validator: (data) => {
        return ['active', 'loading', 'disabled', 'table'].includes(data)
      }
    },
    btnSize: {
      type: String,
      default: 'norm'
    },
    btnLabel: {
      type: String,
      default: 'BTN'
    },
    href: {
      type: String,
      default: 'javascript:;'
    }
  },
  methods: {
    clickBtn () {
      if (['active', 'table'].includes(this.btnStatus)) {
        this.$emit('clickBtn')
      }
    }
  },
  computed: {
    btnClass: {
      get () {
        return {
          'fm-btn-n': this.btnSize === 'norm',
          'fm-btn-l': this.btnSize === 'large',
          'fm-btn-s': this.btnSize === 'small',
          'fm-btn_active': this.btnStatus === 'active',
          'fm-btn_disabled': this.btnStatus === 'disabled',
          'fm-btn_loading': this.btnStatus === 'loading',
          'fm-btn_table': this.btnStatus === 'table'
        }
      }
    }
  }
}
</script>

<style lang="less" scoped>
@import '../styles/value.less';
.fm-btn {
  white-space:nowrap;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: @size-border-radius-m;
  letter-spacing: @size-letter-spacing-m;
}

.fm-btn-n {
  .fm-btn;
  height: 1.88rem;
  padding: 0 1.2rem;
  font-size: @size-font-n;
}

.fm-btn-s {
  .fm-btn;
  height: 1.3rem;
  padding: 0 0.2rem;
  font-size: @size-font-m;
  line-height: 1;
}

.fm-btn-l {
  .fm-btn;
  line-height: 2.2;
  margin: 1.56em 1.88em;
  padding: 0 1.8rem;
  font-size: @size-font-l;
}

.fm-btn_active {
  background-color: #feb37f;
  color: #fff;
}

.fm-btn_active:hover {
  background: #fe954c;
}

.fm-btn_loading {
  background-color: @color-btn-common-bak-g;
  color: @color-btn-common-font-g;
}

.fm-btn_table {
  color: @color-main;
}

.fm-btn_table:hover {
  background: #fe954c;
  color: #fff;
}

.fm-btn_disabled {
  background-color: @color-btn-common-bak-g;
  color: @color-btn-common-font-g;
}
</style>



// WEBPACK FOOTER //
// src/components_bit/FmBtn.vue